<template>

    <div  style="width:1000px;height:600px;">




        <vue-draggable-resizable  :ref="bg_box" :id="bg_box" v-if="setup.BG_BOX.SHOW" :class="editable? '':'no_vdr'" :x="setup.BG_BOX.X" :y="setup.BG_BOX.Y" :w="setup.BG_BOX.WIDTH" :h="setup.BG_BOX.HEIGHT" @dragging="onDrag" @resizing="onResize" :parent="true" >
            <transition
                    :name="setup.BG_BOX.ANIMATION"
            >
            <v-card
                    dark
                    flat
                    style="width:100%;height:100%;"
                    :style="{'background':setup.BG_BOX.COLOR}"
                    @click="$emit('boxfocus',0)"
                    v-show="show_bg"

            >


                    <img v-if="setup.BG_BOX.GIF"
                         style="z-index: 0;height: 100%;width:100%;"
                         :src="setup.BG_BOX.GIF"
                         :ref="img_box"
                         :id="img_box"


                    />



                    <img
                        v-if="setup.BG_BOX.IMAGE"
                        style="position: absolute;z-index: 0;height: 100%;width:100%;"
                        :src="setup.BG_BOX.IMAGE"
                    />





                    <video ref="bg_video" autoplay :muted="!show_bg" loop style="position: absolute;z-index: 0;height: 100%;width:100%;"  v-if="setup.BG_BOX.VIDEO"
                    >
                        <source :src="setup.BG_BOX.VIDEO"/>
                    </video>







                </v-card>
            </transition>

        </vue-draggable-resizable>

        <vue-draggable-resizable v-ripple :ref="amount_box" :id="amount_box"  v-if="setup.AMOUNT_BOX.SHOW" :class="editable? '':'no_vdr'"  :x="setup.AMOUNT_BOX.X" :y="setup.AMOUNT_BOX.Y"  :w="setup.AMOUNT_BOX.WIDTH" :h="setup.AMOUNT_BOX.HEIGHT" @dragging="onDrag" @resizing="onResize" :parent="true">
            <div  style="overflow:hidden;width:100%;height:100%;">
            <transition
                    :name="setup.AMOUNT_BOX.ANIMATION"
            >

                <v-row v-show="show_amount" style="width:100%;height:100%;overflow:hidden;" align="center" justify="center">
                    <v-col align="center">
                    <p
                       @click="$emit('boxfocus',3)" style="width:100%;height:100%;background:transparent;text-shadow: 0 0 3px #000000, 0 0 5px #000000;text-align: center;"  :style="{'font-size':setup.AMOUNT_BOX.FONT_SIZE +'px','color':setup.AMOUNT_BOX.COLOR+' !important'}" :class="'apply-font-amount'+id_given"   >{{amount_box_message}}</p>
                    </v-col>
                </v-row>

            </transition>
            </div>
        </vue-draggable-resizable>

        <vue-draggable-resizable  v-ripple :ref="name_box" :id="name_box"  v-if="setup.NAME_BOX.SHOW"  :class="editable? '':'no_vdr'"  :x="setup.NAME_BOX.X" :y="setup.NAME_BOX.Y"  :w="setup.NAME_BOX.WIDTH" :h="setup.NAME_BOX.HEIGHT" @dragging="onDrag" @resizing="onResize" :parent="true">
            <div  style="overflow:hidden;width:100%;height:100%;">

            <transition
                    :name="setup.NAME_BOX.ANIMATION"
            >
            <v-row v-show="show_name" style="width:100%;height:100%;overflow:hidden;" align="center" justify="center" >
                <v-col align="center"
                >
                    <p  @click="$emit('boxfocus',2)" style="text-align: center;text-shadow: 0 0 3px #000000, 0 0 5px #000000;white-space: normal;"      :class="'apply-font-name'+id_given"             :style="{'font-size':setup.NAME_BOX.FONT_SIZE +'px','color':setup.NAME_BOX.COLOR+' !important'}" >{{name_box_message}}</p>

                </v-col>
            </v-row>
            </transition>
            </div>

        </vue-draggable-resizable>



        <vue-draggable-resizable v-ripple :ref="message_box" :id="message_box" v-if="setup.MESSAGE_BOX.SHOW" :class="editable? '':'no_vdr'"  :x="setup.MESSAGE_BOX.X" :y="setup.MESSAGE_BOX.Y"  :w="setup.MESSAGE_BOX.WIDTH" :h="setup.MESSAGE_BOX.HEIGHT"  @dragging="onDrag" @resizing="onResize" :parent="true">
            <transition
                    :name="setup.MESSAGE_BOX.ANIMATION"
            >
            <v-textarea
                    v-show="show_message"
                    @click="$emit('boxfocus',1)"
                    solo
                    name="input-7-4"
                    label="Solo textarea"
                    class="ME_BIG"
                    :class="'apply-font-message'+id_given"
                    :style="{'font-size':setup.MESSAGE_BOX.FONT_SIZE +'px','color':setup.MESSAGE_BOX.COLOR+' !important'}"
                    style="text-align:center;text-shadow: 0 0 3px #000000, 0 0 5px #000000;bottom:0;height:100%;width:100%;"
                    :value="CLEAN_MESSAGE"
                    readonly
                    color="red"
                    ref="message_text_area"
            ></v-textarea>
            </transition>
        </vue-draggable-resizable>

        <font-picker
                :options="{
                                        name: 'message'+id_given
                                        }"
                style="visibility: hidden;"
                :active-font="setup.MESSAGE_BOX.FONT"
                :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                class="font_pick"
        ></font-picker>
        <font-picker
                :options="{
                                        name: 'name'+id_given
                                        }"
                style="visibility: hidden;"
                :active-font="setup.NAME_BOX.FONT"
                :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                class="font_pick"
        ></font-picker>
        <font-picker
                :options="{
                                        name: 'amount'+id_given
                                        }"
                style="visibility: hidden;"
                :active-font="setup.AMOUNT_BOX.FONT"
                :api-key="'AIzaSyDAiLD4uruyYeaub20yX_zJpWtagUarpWA'"
                class="font_pick"
        ></font-picker>


    </div>

</template>

<script>
    import FontPicker from 'font-picker-vue';
    export default {
        name: "StandardAlert",
        components: {
            FontPicker
        },
        props:["data","setup","editable","id_given","locked"],
        data: () => ({

            amount_box_height:"20px",
            message_box_height:"20px",
            name_box_height:"20px",
            is_scrolling:false,
            show_bg_i:false,
            show_message_i:false,
            show_amount_i:false,
            show_name_i:false,
            timeouts:[],
            gif:null,
            the_width:"1000 px",
            CLEAN_MESSAGE:null,
            CLEAN_NAME:null








        }),
        mounted:function(){
            this.CLEAN_MESSAGE=this.data.MESSAGE;
            this.CLEAN_NAME=this.data.SENDER_NAME;


            let self=this;
            setInterval(function(){
                if(self.$refs.message_text_area){
                    let text_area=self.$refs.message_text_area.$el.getElementsByTagName("textarea")[0];

                    if(!self.is_scrolling && text_area){
                        self.scrollText(text_area);
                    }
                }

            },1000);
            if(this.locked && this.setup.BG_BOX.VIDEO){
                this.$refs.bg_video.currentTime=parseInt(this.setup.DURATION)/2;
                this.$refs.bg_video.pause();

            }
            if(document.getElementById("be_like_me")){
                this.the_width=document.getElementById("be_like_me").clientWidth +"px";
            }





        },
        computed:{

            watch_width:function(){
                return document.getElementById("be_like_me").clientWidth
            },

            name_box_message:function(){
                let the_s=this.setup.NAME_BOX.TEMPLATE.replace("<NAMN>",this.CLEAN_NAME).replace("<SUMMA>",this.data.AMOUNT);
                return the_s
            },
            amount_box_message:function(){
                let the_s=this.setup.AMOUNT_BOX.TEMPLATE.replace("<NAMN>",this.CLEAN_NAME).replace("<SUMMA>",this.data.AMOUNT);
                return the_s
            },

            show_bg:function(){
              if(this.locked){
                  return true
              }
              else if(this.show_bg_i){
                  return true
              }
              else{
                  return false
              }
            },
            show_message:function(){
                if(this.locked){
                    return true
                }
                else if(this.show_message_i){
                    return true
                }
                else{
                    return false
                }
            },
            show_name:function(){
                if(this.locked){
                    return true
                }
                else if(this.show_name_i){
                    return true
                }
                else{
                    return false
                }
            },
            show_amount:function(){
                if(this.locked){
                    return true
                }
                else if(this.show_name_i){
                    return true
                }
                else{
                    return false
                }
            },

            bg_box:function(){
              return "bg_box"+this.id_given;
            },
            amount_box:function(){
                return "amount_box"+this.id_given;
            },
            message_box:function(){
                return "message_box"+this.id_given;
            },
            name_box:function(){
                return "name_box"+this.id_given;
            },
            img_box:function(){
                return "img_box"+this.id_given;
            }

        },


        methods:{


            message:function(){
                this.clean();
                let self=this;
                this.show_bg_i=false;
                this.show_message_i=false;
                this.show_amount_i=false;
                this.show_name_i=false;
                this.timeouts.forEach(function(timeout){
                    clearTimeout(timeout);
                });
                this.data.AMOUNT=parseInt(this.data.AMOUNT);
                this.data.MIN_DONATION=parseInt(this.data.MIN_DONATION);
                if(this.setup.MAX_DONATION!==null && this.setup.MAX_DONATION!=="Ingen"){
                    this.data.MAX_DONATION=parseInt(this.data.MAX_DONATION);
                }

                if((this.data.AMOUNT< this.setup.MIN_DONATION) || (this.data.AMOUNT>this.setup.MAX_DONATION && (this.setup.MAX_DONATION!==null && this.setup.MAX_DONATION!=="Ingen" && this.setup.MAX_DONATION!=="NaN")))
                {
                    console.log(this.setup.MIN_DONATION);
                    console.log(this.data.AMOUNT>this.setup.MAX_DONATION);
                    console.log(this.setup.MAX_DONATION!==null);
                    console.log(this.setup.MAX_DONATION!=="Ingen");

                    console.log("amount not in range kappa");
                    self.$emit("donation_done")

                }
                else{
                    //BG
                if(this.setup.BG_BOX.GIF){
                    this.gif=this.setup.BG_BOX.GIF;
                    this.setup.BG_BOX.GIF="";
                    document.getElementById(this.img_box).src="";
                }
                this.timeouts.push(setTimeout(function(){
                    self.show_bg_i=true;
                    if(self.setup.BG_BOX.VIDEO){
                        self.$refs.bg_video.currentTime="0";
                        self.$refs.bg_video.play();
                    }
                    else if(self.setup.BG_BOX.GIF===""){

                        self.setup.BG_BOX.GIF=self.gif;

                    }


                },self.setup.BG_BOX.RANGE[0]*1000));
                this.timeouts.push(setTimeout(function(){
                    self.show_bg_i=false;
                },self.setup.BG_BOX.RANGE[1]*1000))
                //MESSAGE
                this.timeouts.push(setTimeout(function(){
                    self.show_message_i=true;
                },self.setup.MESSAGE_BOX.RANGE[0]*1000));
                this.timeouts.push(setTimeout(function(){
                    self.show_message_i=false;
                },self.setup.MESSAGE_BOX.RANGE[1]*1000))
                //AMOUNT
                this.timeouts.push(setTimeout(function(){
                    self.show_amount_i=true;
                },self.setup.AMOUNT_BOX.RANGE[0]*1000));
                this.timeouts.push(setTimeout(function(){
                    self.show_amount_i=false;
                },self.setup.AMOUNT_BOX.RANGE[1]*1000))
                //NAME
                this.timeouts.push(setTimeout(function(){
                    self.show_name_i=true;
                },self.setup.NAME_BOX.RANGE[0]*1000));
                this.timeouts.push(setTimeout(function(){
                    self.show_name_i=false;
                },self.setup.NAME_BOX.RANGE[1]*1000))
                if(this.setup.SOUND){
                    let src=`https://hihat.io${this.setup.SOUND}`
                    var audio = new Audio(src);
                    audio.play();
                }
                if(this.setup.TTS!==false && parseInt(this.setup.MIN_TTS)<=this.data.AMOUNT){
                    this.speak();
                }
                setTimeout(function(){
                    self.$emit("donation_done")
                },self.setup.DURATION*1000);
                }

            },
            clean:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/clean_text';

                let self=this;
                let params ="MESSAGE="+this.data.MESSAGE+"&NAME="+this.data.SENDER_NAME+"&BAD="+this.setup.BAD_WORDS;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200) {
                        let data=JSON.parse(http.responseText);
                        self.CLEAN_MESSAGE=data.MESSAGE;
                        self.CLEAN_NAME=data.NAME;





                    }
                };
                http.send(params);
                console.log("SPEAKING!")
            },

            speak:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_voice';
                let lang="";
                if(this.setup.TTS==="Svenska"){
                    lang="sv-SE"
                }
                else if(this.setup.TTS==="Engelska"){
                    lang="en-US"
                }
                else if(this.setup.TTS==="Norska"){
                    lang="no-NO"
                }

                let params ="MESSAGE="+this.data.MESSAGE+"&LANG="+lang+"&BAD="+this.setup.BAD_WORDS;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200) {
                        setTimeout(function(){
                            let src=`https://hihat.io/api/tts-temp/${http.responseText}.mp3`;
                            let audio=new Audio(src);
                            audio.play();
                        },3000);




                    }
                };
                http.send(params);
                console.log("SPEAKING!")
            },

            reset_bg:function(SETUP) {
                this.$refs[this.bg_box].top = SETUP.BG_BOX.Y;
                this.$refs[this.bg_box].left = SETUP.BG_BOX.X;
                this.$refs[this.bg_box].w = SETUP.BG_BOX.WIDTH;
                this.$refs[this.bg_box].h = SETUP.BG_BOX.HEIGHT;
                this.$refs[this.bg_box].width = SETUP.BG_BOX.WIDTH;
                this.$refs[this.bg_box].height = SETUP.BG_BOX.HEIGHT;


                document.getElementById(this.bg_box).style.transform = `translate(${SETUP.BG_BOX.X}px, ${SETUP.BG_BOX.Y}px)`;
                document.getElementById(this.bg_box).style.width = `${SETUP.BG_BOX.WIDTH}px`;
                document.getElementById(this.bg_box).style.height = `${SETUP.BG_BOX.HEIGHT}px`;


            },
            reset_amount:function(SETUP) {
                this.$refs[this.amount_box].top = SETUP.AMOUNT_BOX.Y;
                this.$refs[this.amount_box].left = SETUP.AMOUNT_BOX.X;
                this.$refs[this.amount_box].w = SETUP.AMOUNT_BOX.WIDTH;
                this.$refs[this.amount_box].h = SETUP.AMOUNT_BOX.HEIGHT;
                this.$refs[this.amount_box].width = SETUP.AMOUNT_BOX.WIDTH;
                this.$refs[this.amount_box].height = SETUP.AMOUNT_BOX.HEIGHT;


                document.getElementById(this.amount_box).style.transform = `translate(${SETUP.AMOUNT_BOX.X}px, ${SETUP.AMOUNT_BOX.Y}px)`;
                document.getElementById(this.amount_box).style.width = `${SETUP.AMOUNT_BOX.WIDTH}px`;
                document.getElementById(this.amount_box).style.height = `${SETUP.AMOUNT_BOX.HEIGHT}px`;
            },
            reset_name:function(SETUP) {
                this.$refs[this.name_box].top = SETUP.NAME_BOX.Y;
                this.$refs[this.name_box].left = SETUP.NAME_BOX.X;
                this.$refs[this.name_box].w = SETUP.NAME_BOX.WIDTH;
                this.$refs[this.name_box].h = SETUP.NAME_BOX.HEIGHT;
                this.$refs[this.name_box].width = SETUP.NAME_BOX.WIDTH;
                this.$refs[this.name_box].height = SETUP.NAME_BOX.HEIGHT;


                document.getElementById(this.name_box).style.transform = `translate(${SETUP.NAME_BOX.X}px, ${SETUP.NAME_BOX.Y}px)`;
                document.getElementById(this.name_box).style.width = `${SETUP.NAME_BOX.WIDTH}px`;
                document.getElementById(this.name_box).style.height = `${SETUP.NAME_BOX.HEIGHT}px`;
            },
            reset_message:function(SETUP){
                this.$refs[this.message_box].top = SETUP.MESSAGE_BOX.Y;
                this.$refs[this.message_box].left = SETUP.MESSAGE_BOX.X;
                this.$refs[this.message_box].w = SETUP.MESSAGE_BOX.WIDTH;
                this.$refs[this.message_box].h = SETUP.MESSAGE_BOX.HEIGHT;
                this.$refs[this.message_box].width = SETUP.MESSAGE_BOX.WIDTH;
                this.$refs[this.message_box].height = SETUP.MESSAGE_BOX.HEIGHT;


                document.getElementById(this.message_box).style.transform = `translate(${SETUP.MESSAGE_BOX.X}px, ${SETUP.MESSAGE_BOX.Y}px)`;
                document.getElementById(this.message_box).style.width = `${SETUP.MESSAGE_BOX.WIDTH}px`;
                document.getElementById(this.message_box).style.height = `${SETUP.MESSAGE_BOX.HEIGHT}px`;
            },
            save:function(){
                let SETUP={
                    "BG_BOX":{

                    },
                    "MESSAGE_BOX":{

                    },
                    "NAME_BOX":{

                    },
                    "AMOUNT_BOX":{

                    }};
                if(this.setup.BG_BOX.SHOW){
                    SETUP.BG_BOX={
                            "X":this.$refs[this.bg_box].left,
                            "Y":this.$refs[this.bg_box].top,
                            "WIDTH":this.$refs[this.bg_box].width,
                            "HEIGHT":this.$refs[this.bg_box].height

                        };
                }
                if(this.setup.MESSAGE_BOX.SHOW){


                    SETUP.MESSAGE_BOX={
                        "X":this.$refs[this.message_box].left,
                        "Y":this.$refs[this.message_box].top,
                        "WIDTH":this.$refs[this.message_box].width,
                        "HEIGHT":this.$refs[this.message_box].height
                    };
                }
                if(this.setup.NAME_BOX.SHOW){

                    SETUP.NAME_BOX={
                        "X":this.$refs[this.name_box].left,
                        "Y":this.$refs[this.name_box].top,
                        "WIDTH":this.$refs[this.name_box].width,
                        "HEIGHT":this.$refs[this.name_box].height
                    };
                }
                if(this.setup.AMOUNT_BOX.SHOW){

                    SETUP.AMOUNT_BOX={
                        "X":this.$refs[this.amount_box].left,
                        "Y":this.$refs[this.amount_box].top,
                        "WIDTH":this.$refs[this.amount_box].width,
                        "HEIGHT":this.$refs[this.amount_box].height
                    }
                }
                return SETUP


            },

            scrollText:function(text_area){
                text_area.scrollTop = 0;
                let self=this;
                if(text_area.clientHeight < text_area.scrollHeight) {
                    this.is_scrolling=true;


                    let scrolling = setInterval(function () {
                        text_area.scrollTop = text_area.scrollTop + 1 % text_area.clientHeight;
                        if (text_area.scrollTop >= text_area.scrollHeight - text_area.clientHeight) {
                            clearInterval(scrolling);
                            self.is_scrolling=false;

                        }
                    }, 100);
                }

            },
            onResize: function (x, y, width, height) {
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
            },
            onDrag: function (x, y) {
                this.x = x;
                this.y = y;
            },

            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#3f3f3f"
                }
            }
        },
        watch:{
            locked:function(){
                if(this.locked && this.setup.BG_BOX.VIDEO){
                    this.$refs.bg_video.currentTime=parseInt(this.setup.DURATION)/2;
                    this.$refs.bg_video.pause();

                }
                else if(this.locked && this.setup.BG_BOX.IMAGE){
                    if(this.setup.BG_BOX.IMAGE.includes(".gif")){
                        this.$refs[this.img_box].stop();

                    }


                }
            }

        }


    }

</script>

<style>
    .ME_BIG > * {
        position: relative !important;
        min-height:100% !important;
        height:100% !important;
        max-height: 100% !important;
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
        text-shadow: 0 0 3px #000000, 0 0 5px #000000;
    }
    .ME_BIG{
        position: relative !important;
        min-height:100% !important;
        height:100% !important;
        box-shadow:none !important;
        -webkit-box-shadow: none !important;

        max-height: 100% !important;
    }
    .ME_BIG > * textarea{
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
        color: inherit !important;
        text-align: center;
        text-shadow: rgb(0, 0, 0) 0px 0px 3px, rgb(0, 0, 0) 0px 0px 5px;
    }
    .v-input__slot{
        box-shadow:none !important;
        -webkit-box-shadow: none !important;
    }

    ::-webkit-scrollbar {
        width: 0;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent;
    }

    .vdr{
        border: none !important;
    }

    textarea {
        resize: none;
    }

    .ff-image{
        height:100% !important;
        width:100% !important;
    }

    .ff-container{
        height:100% !important;
        width:100% !important;
    }


</style>
